function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32.93,
    height: 18.86,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.143333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 9.43
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.86,
    width: 32.93,
    height: 30.03,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.336666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 33.875
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 48.89,
    width: 32.93,
    height: 31.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 64.415
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.94,
    width: 32.93,
    height: 34.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 97.22
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.5,
    width: 32.93,
    height: 35.95,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 132.475
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 150.45,
    width: 32.93,
    height: 36.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 168.76999999999998
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.08,
    width: 32.93,
    height: 37.3,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.586
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 205.73000000000002
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 224.38,
    width: 32.93,
    height: 39.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 244.18
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.98,
    width: 32.93,
    height: 40.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 284.125
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.27,
    width: 32.93,
    height: 42.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.293
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 325.40999999999997
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 346.54,
    width: 32.93,
    height: 43.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 368.095
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 389.65,
    width: 32.93,
    height: 46.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 412.655
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 435.66,
    width: 32.93,
    height: 46.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.2325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 458.69500000000005
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 481.73,
    width: 32.93,
    height: 48.22,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.704285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 505.84000000000003
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 529.95,
    width: 32.93,
    height: 55.61,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 557.755
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 585.55,
    width: 32.93,
    height: 56.74,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.488333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 613.92
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 642.29,
    width: 32.93,
    height: 57.71,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.293
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.465,
    y: 671.145
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 0,
    width: 39.02,
    height: 48.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.503333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.44,
    y: 24.365
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.94,
    y: 0,
    width: 40.36,
    height: 48.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.726666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.12,
    y: 24.365
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.3,
    y: 0,
    width: 41.91,
    height: 48.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.191
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.255,
    y: 24.365
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.22,
    y: 0,
    width: 42.58,
    height: 48.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.51,
    y: 24.365
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.8,
    y: 0,
    width: 42.86,
    height: 48.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.122857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.23000000000002,
    y: 24.365
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.66,
    y: 0,
    width: 45.03,
    height: 48.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.175,
    y: 24.365
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.7,
    y: 0,
    width: 46.15,
    height: 48.73,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.195454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.775,
    y: 24.365
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.85,
    y: 0,
    width: 48.77,
    height: 48.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.414444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.235,
    y: 24.365
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.62,
    y: 0,
    width: 48.86,
    height: 48.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.414444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.05,
    y: 24.365
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.48,
    y: 0,
    width: 50.21,
    height: 48.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.58500000000004,
    y: 24.365
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.69,
    y: 0,
    width: 53.25,
    height: 48.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.09125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.315,
    y: 24.365
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.94,
    y: 0,
    width: 54.19,
    height: 48.73,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.745999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.0350000000001,
    y: 24.365
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.13,
    y: 0,
    width: 56.11,
    height: 48.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.185,
    y: 24.365
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.24,
    y: 0,
    width: 57.76,
    height: 48.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.12,
    y: 24.365
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 48.73,
    width: 58.73,
    height: 49.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.298333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 73.625
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 98.52,
    width: 58.73,
    height: 49.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1625000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 123.495
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 148.47,
    width: 58.73,
    height: 50.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 173.87
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 199.27,
    width: 58.73,
    height: 51.64,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 225.09
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 250.91,
    width: 58.73,
    height: 52.2,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.800000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 277.01
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 303.11,
    width: 58.73,
    height: 53.56,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9511111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 329.89
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 356.67,
    width: 58.73,
    height: 53.79,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 383.565
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 410.46,
    width: 58.73,
    height: 55.93,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 438.42499999999995
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 466.39,
    width: 58.73,
    height: 56.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.388
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 494.86
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 523.33,
    width: 58.73,
    height: 57.56,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.593333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 552.11
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 580.89,
    width: 58.73,
    height: 57.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 609.8
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 638.72,
    width: 58.73,
    height: 61.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.389999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.295,
    y: 669.36
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 48.73,
    width: 57.27,
    height: 65.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.295,
    y: 81.66999999999999
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.93,
    y: 48.73,
    width: 58.25,
    height: 65.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.055,
    y: 81.66999999999999
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.18,
    y: 48.73,
    width: 58.42,
    height: 65.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.684000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.39000000000001,
    y: 81.66999999999999
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 48.73,
    width: 58.97,
    height: 65.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.08500000000004,
    y: 81.66999999999999
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.57,
    y: 48.73,
    width: 60.14,
    height: 65.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.59142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.64,
    y: 81.66999999999999
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.71,
    y: 48.73,
    width: 60.6,
    height: 65.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 415.01,
    y: 81.66999999999999
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.31,
    y: 48.73,
    width: 61.71,
    height: 65.88,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.71375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.165,
    y: 81.66999999999999
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.02,
    y: 48.73,
    width: 63.92,
    height: 65.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.392
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.98,
    y: 81.66999999999999
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.94,
    y: 48.73,
    width: 64.28,
    height: 65.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.713333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.08,
    y: 81.66999999999999
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.21,
    y: 48.73,
    width: 64.79,
    height: 65.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.19888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.605,
    y: 81.66999999999999
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 114.61,
    width: 68.58,
    height: 62.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 146.075
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 177.54,
    width: 68.58,
    height: 63.91,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 209.495
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 241.45,
    width: 68.58,
    height: 64.66,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.776666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 273.78
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 306.1,
    width: 68.58,
    height: 64.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 338.47
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 370.84,
    width: 68.58,
    height: 64.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.12125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 403.325
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 435.81,
    width: 68.58,
    height: 65.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.898333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 468.505
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 501.2,
    width: 68.58,
    height: 65.8,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 534.1
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 567,
    width: 68.58,
    height: 65.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.163999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 599.91
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.66,
    y: 632.82,
    width: 68.58,
    height: 67.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.94999999999999,
    y: 666.4100000000001
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 114.61,
    width: 61.69,
    height: 76.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.169
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.085,
    y: 153.01999999999998
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.93,
    y: 114.61,
    width: 63.65,
    height: 76.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.95625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 253.755,
    y: 153.01999999999998
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.57,
    y: 114.61,
    width: 66.04,
    height: 76.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.208000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.59,
    y: 153.01999999999998
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.61,
    y: 114.61,
    width: 66.22,
    height: 76.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.72,
    y: 153.01999999999998
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.83,
    y: 114.61,
    width: 68.6,
    height: 76.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.13,
    y: 153.01999999999998
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486.43,
    y: 114.61,
    width: 69.13,
    height: 76.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.681111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.995,
    y: 153.01999999999998
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.56,
    y: 114.61,
    width: 72.2,
    height: 76.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.66,
    y: 153.01999999999998
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.76,
    y: 114.61,
    width: 72.24,
    height: 76.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.88,
    y: 153.01999999999998
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 191.43,
    width: 73.85,
    height: 76.8,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.23125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16500000000002,
    y: 229.83
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 268.23,
    width: 73.85,
    height: 79.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.549999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16500000000002,
    y: 308.105
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 347.97,
    width: 73.85,
    height: 84.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16500000000002,
    y: 390.225
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 432.48,
    width: 73.85,
    height: 89.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.549999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16500000000002,
    y: 477.045
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 521.61,
    width: 73.85,
    height: 89.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.549999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16500000000002,
    y: 566.1800000000001
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.24,
    y: 610.75,
    width: 73.85,
    height: 89.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.16500000000002,
    y: 655.375
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.08,
    y: 191.43,
    width: 89.17,
    height: 77.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.553999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.665,
    y: 230.315
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.25,
    y: 191.43,
    width: 91.07,
    height: 77.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.78499999999997,
    y: 230.315
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.32,
    y: 191.43,
    width: 94.97,
    height: 77.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.776999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.805,
    y: 230.315
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.29,
    y: 191.43,
    width: 95.23,
    height: 77.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.64111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.905,
    y: 230.315
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.52,
    y: 191.43,
    width: 95.48,
    height: 77.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.961666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.26,
    y: 230.315
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.08,
    y: 269.19,
    width: 92.41,
    height: 80.75,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.458333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.285,
    y: 309.565
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.08,
    y: 349.94,
    width: 92.41,
    height: 82.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.827142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.285,
    y: 391.335
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.08,
    y: 432.73,
    width: 92.41,
    height: 85.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.285,
    y: 475.67
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.08,
    y: 518.62,
    width: 92.41,
    height: 89.81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.981
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.285,
    y: 563.525
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.08,
    y: 608.43,
    width: 92.41,
    height: 91.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.261666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.285,
    y: 654.2149999999999
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.49,
    y: 269.19,
    width: 87,
    height: 100.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.99,
    y: 319.245
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.49,
    y: 269.19,
    width: 89.8,
    height: 100.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.39,
    y: 319.245
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.29,
    y: 269.19,
    width: 97.83,
    height: 100.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.22875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.205,
    y: 319.245
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.12,
    y: 269.19,
    width: 98.88,
    height: 100.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.125714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.56,
    y: 319.245
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.49,
    y: 369.3,
    width: 93.76,
    height: 109.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.752000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.37,
    y: 424.21000000000004
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.49,
    y: 479.12,
    width: 93.76,
    height: 110.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.394285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.37,
    y: 534.175
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.49,
    y: 589.23,
    width: 93.76,
    height: 110.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.37,
    y: 644.615
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.25,
    y: 369.3,
    width: 89.68,
    height: 117.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.09000000000003,
    y: 428.27500000000003
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.93,
    y: 369.3,
    width: 90.1,
    height: 117.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.98,
    y: 428.27500000000003
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.03,
    y: 369.3,
    width: 99.97,
    height: 117.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.661666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.015,
    y: 428.27500000000003
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.25,
    y: 487.25,
    width: 126.89,
    height: 105.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.610909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.695,
    y: 540.11
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.25,
    y: 592.98,
    width: 126.89,
    height: 107.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.288571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.695,
    y: 646.49
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.14,
    y: 487.25,
    width: 152.86,
    height: 104.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.5699999999999,
    y: 539.47
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.14,
    y: 591.69,
    width: 152.86,
    height: 108.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.53875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.5699999999999,
    y: 645.845
  }, "\n        Buncombe\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.b28f3d2359eb7bc0aaf111c2301e8c80.svg";
export { ForwardRef as ReactComponent };